<template>
  <div v-if="!complete">
    <next-button @click="openAddressModal" :text="'Add an Address'" />
    <servicer-payoff-address-form-modal
      v-if="modalOpen"
      :stipulation="stip"
      @close="closeAddressModal"
			@success="emit('success', $event)"
    />
  </div>
</template>
<script setup lang="ts">
import { useStore } from "vuex";
import { computed } from "vue";
import type { Stipulation } from "@/models/opal";
import NextButton from "@/components/shared/NextButton.vue";
import ServicerPayoffAddressFormModal from "@/components/modals/ServicerPayoffAddressFormModal.vue";
import { StipulationStatusIds } from "@/config/constants";

const store = useStore();

interface Props {
  stip: Stipulation;
}

const props = withDefaults(defineProps<Props>(), {});

const emit = defineEmits<{
  (e: "success", updatedStip: Stipulation): void;
}>();

const complete = computed(
  () =>
    props.stip.stipulationStatusId === StipulationStatusIds.COMPLETED ||
    props.stip.stipulationStatusId === StipulationStatusIds.CU_OVERRIDE,
);

const modalOpen = computed(() => store.state.modal.servicerPayoffAddressModalActive);

function openAddressModal() {
  store.state.forms.servicerPayoffAddressForm.applicationStipulationId = props.stip?.id;
  store.dispatch("forms/setServicerPayoffAddressForm", store.state.forms.servicerPayoffAddressForm);
  store.dispatch("modal/openServicerPayoffAddressModal");
}

function closeAddressModal() {
  store.dispatch("modal/closeServicerPayoffAddressModal");
}
</script>
